import styled from 'styled-components';

export const TypographyRowsContainer = styled.div<{ paddingLeft: string }>`
  padding-left: ${props => (props.paddingLeft ? props.paddingLeft : props.theme.space['1.0'])};
`;
